import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";

const Welcome = () => (
  <div data-testid="welcome-page" className="mx-auto flex min-h-[80vh] max-w-md flex-col items-center justify-center px-4 py-16 text-center">
    <CheckCircle size={40} weight="bold" className="mb-4 text-green-400" />
    <h1 className="font-heading text-3xl uppercase tracking-tight text-white sm:text-4xl">Welcome to EdgeBall Pro</h1>
    <p className="mt-3 text-sm leading-relaxed text-zinc-400 sm:text-base">
      Your subscription is active. You now have full access to Largest Leans, Line Movement, and every EdgeBall feature.
    </p>
    <Link
      to="/"
      data-testid="welcome-dashboard-link"
      className="mt-8 flex items-center gap-2 rounded-md bg-eb-accent px-6 py-3 font-heading text-sm uppercase tracking-wide text-white transition-colors hover:bg-blue-600"
    >
      Go to Dashboard <ArrowRight size={16} weight="bold" />
    </Link>
  </div>
);

export default Welcome;
